import axios from 'axios';
import { baseUrl } from '../../config';

export const healthCheck = () => axios.get(`${baseUrl}/management/health`);
